/**
 * URL base da API (apps/api). A API sobe na porta 3001 por padrão.
 * Ordem: 1) VITE_API_URL no .env  2) Se acessando de localhost → http://localhost:3001  3) dev → localhost  4) produção → api.unipapo.com.br
 */
const fromEnv = import.meta.env.VITE_API_URL || import.meta.env.FRONT_API_URL;
const fromEnvTrimmed = typeof fromEnv === 'string' ? fromEnv.trim() : '';
const isLocalhost =
  typeof window !== 'undefined' &&
  (window.location?.hostname === 'localhost' || window.location?.hostname === '127.0.0.1');
const dev = import.meta.env.DEV;

export const API_BASE_URL =
  fromEnvTrimmed ||
  (isLocalhost ? 'http://localhost:3001' : null) ||
  (dev ? 'http://localhost:3001' : 'https://api.unipapo.com.br');
